@if (expressPayMethod) {
  <!-- Wrapper matches what the funnel CTA had before this component existed: the wallet pair
       sits in its own centred column. It only stretches on the credits card, whose buttons
       fill their container. -->
  <div class="d-flex flex-column align-items-center" [class.w-100]="size === 'sm'">
    <button
      class="express-payment-button"
      [class.express-payment-button-sm]="size === 'sm'"
      [class.mb-10]="size === 'sm'"
      (click)="walletButtonClicked()"
      [attr.aria-label]="expressPayMethod === 'apple_pay' ? applePayAriaLabel : googlePayAriaLabel"
    >
      <!-- ng-container, not a bare interpolation: the whitespace before the glyph must stay a
           whitespace-only node so Angular strips it, leaving ms-5 to own the gap. -->
      <ng-container>{{ walletActionLabel }}</ng-container>
      <i
        class="{{
          expressPayMethod === 'apple_pay' ? 'ri-apple-fill ms-5' : 'ri-google-fill ms-5'
        }}"
      ></i
      >Pay
    </button>
    <button
      mat-button
      class="mt-5 payment-methods-button"
      [class.payment-methods-button-sm]="size === 'sm'"
      (click)="otherOptionsClicked.emit()"
    >
      <ng-container i18n="@@continueWithOtherPaymentOptions">
        Continue with other payment options
      </ng-container>
    </button>
  </div>
} @else {
  <!-- No wallet here, so the only way forward is the full checkout — the same destination the
       "other payment options" link above leads to. -->
  <button
    mat-flat-button
    class="tagus express-continue-button"
    [class.express-continue-button-sm]="size === 'sm'"
    [class.w-100]="size === 'sm'"
    (click)="activate()"
  >
    {{ continueButtonTitle }}
  </button>
}

@if (isProcessing) {
  <div class="mt-16 d-flex flex-column align-items-center">
    <mat-spinner mode="indeterminate" [diameter]="spinnerDiameter"></mat-spinner>
    @if (processingLabel) {
      <div class="muted-color mt-10">{{ processingLabel }}</div>
    }
  </div>
}
